var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-filters-settings"},[_c('filters',{staticStyle:{"margin-top":"16px"},attrs:{"id":_vm.id,"layer-style":_vm.layerStyle,"controllers":_vm.controllers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }